var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('head-nav',{on:{"result":_vm.reserve}}),_c('left-menu',{staticClass:"leftMenu",attrs:{"isCollapse":_vm.isCollapse}}),_c('BreadcrumbNav',{class:[_vm.isCollapse ? 'BreadcrumbNav':'BreadcrumbNavFull']}),_c('div',{class:[_vm.isCollapse ? 'rightContainer':'rightContainerFull']},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }